export class ExternalWarehouseSaturationData {
  constructor(
    public readonly zoneCode: string,
    public readonly currentStock: number,
    public readonly maxCapacity: number,
    public readonly availableCapacity: number,
    public readonly occupancyPercentage: number
  ) {}
}
